module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz7.dc684f77.mp3";